
import React from 'react';

export const ListBulletIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    list
  </span>
);